import PropTypes from 'prop-types';
import cn from "../../../../../utils/cn";
import { jsx as _jsx } from "react/jsx-runtime";
function ClearSelections(_ref) {
  let {
    onClick,
    allOptionsSelected
  } = _ref;
  const clearAllClass = cn('px-2.5 py-0 pb-1 text-right block text-sm text-action-blue font-medium-font', {
    'border-b border-light-border-blue border-solid': !allOptionsSelected
  });
  return /*#__PURE__*/_jsx("div", {
    className: clearAllClass,
    children: /*#__PURE__*/_jsx("button", {
      type: "button",
      onClick: onClick,
      className: "bg-transparent border-none p-0 m-0 text-action-blue font-medium-font text-sm cursor-pointer",
      children: "Clear All"
    })
  });
}
ClearSelections.propTypes = {
  allOptionsSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
export default ClearSelections;
//# sourceMappingURL=ClearSelections.js.map